import DataGrid, { Column, Pager, Paging, Scrolling, SearchPanel, Summary, TotalItem } from 'devextreme-react/cjs/data-grid';
import React, { useState } from 'react'
import { Button, Card } from 'react-bootstrap';
import { GenerateisStoreToMainStoreRepairChallan, generateRepairBag, GenerateRepairChallan, getRepairedBagList, getRepairProductBagList, GetRepairProductsList, getRepairReceipt } from '../services';
import CustomStore from 'devextreme/data/custom_store';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import notistack from 'modules/core/notistack';
import PdfViewerModal from './PdfViewerModal';

const RepairedBagList = () => {
    const [showPdfModal, setShowPdfModal] = useState(false);
    const [pdfData, setPdfData] = useState<string | null>(null);

    const dataSource = (): any | undefined => {
        return new CustomStore({
            key: 'id',
            load: async (loadOptions) => {
                try {
                    const search = JSON.parse(JSON.stringify(loadOptions));
                    let parameterList = new URLSearchParams();
                    for (const [key, value] of Object.entries(search)) {
                        parameterList.append(key, JSON.stringify(value));
                    }
                    const response = await getRepairedBagList();
                    return response;
                } catch (error) {
                    console.error("Data loading error:", error);
                    return { data: [], totalCount: 0 };
                }
            }
        });
    }
    const handleRepairReceipt = async (data: any) => {
        try {
            setShowPdfModal(true)
            const response = await GenerateisStoreToMainStoreRepairChallan(data)
            setPdfData(response.data)
        } catch (error: any) {
            notistack.error(error.message)
        }
    }

    const handleRepairReceipt1 = async (data: any) => {
        try {
            setShowPdfModal(true)
            const response = await GenerateRepairChallan(data)
            setPdfData(response.data)
        } catch (error: any) {
            notistack.error(error.message)
        }
    }

    const formatDate = (dateString: string): string => {

        const utcDateString = dateString.endsWith('Z') ? dateString : dateString + 'Z';
        const date = new Date(utcDateString);

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12;
        const formattedHours = String(hours).padStart(2, '0');

        const formattedDate = `${day}/${month}/${year}`;
        const formattedTime = `${formattedHours}:${minutes}:${seconds} ${ampm}`;

        const fullFormatted = `${formattedDate} ${formattedTime}`;

        return fullFormatted;
    };


    return (
        <>
            <div className="page-content">
                <div className="container-fluid">
                    <Card>
                        <Card.Header className='d-flex justify-content-between align-items-center'>
                            <h5 className='m-0'>Repair Bag List</h5>
                        </Card.Header>
                        <Card.Body className="pt-0">
                            {/* {HasPermission("MetalColor.Read") ? */}
                            <DataGrid
                                dataSource={dataSource()}
                                remoteOperations={{ groupPaging: true }}
                                showRowLines={true}
                                keyExpr="id"
                                showBorders={true}
                            >
                                <Scrolling
                                    mode='standard'
                                    useNative={true}
                                    scrollByContent={true}
                                    scrollByThumb={true}
                                />
                                <Pager
                                    showPageSizeSelector={true}
                                    allowedPageSizes={[10, 25, 50, 100]}
                                    showNavigationButtons={true}
                                    displayMode="full"
                                    showInfo={true}
                                />

                                <Summary>
                                    <TotalItem
                                    // column="bagNo"
                                    // summaryType="count"
                                    // displayFormat="Total: {0} Bags"
                                    />
                                </Summary>

                                <Paging defaultPageSize={10} />
                                <SearchPanel visible width={240} placeholder="Search..." />
 <Column
                                    caption="Action"
                                    width="15%"
                                    allowFiltering={false}
                                    cssClass="text-center"
                                    cellRender={({ data }) => (
                                        <div className="d-flex justify-content-center align-items-center gap-2">
                                            <button className='btn btn-sm action-btn' title='Delivery Challan' onClick={() => handleRepairReceipt(data.id)}>
                                                <FontAwesomeIcon icon={faFilePdf} className="ml-2 text-danger" />
                                            </button>

                                            <button className='btn btn-sm action-btn' title='Delivery Challan' onClick={() => handleRepairReceipt1(data.id)}>
                                                <FontAwesomeIcon icon={faFilePdf} className="ml-2 text-danger" />
                                            </button>
                                        </div>
                                    )}
                                />
                                <Column dataField="bagNo" caption="BagNo." />
                                <Column dataField="createdOn" caption="Created On" dataType="datetime" calculateDisplayValue={(rowData) => formatDate(rowData.createdOn)} />
                                <Column dataField="fromStore" caption="From Store" />
                                <Column dataField="toStore" caption="To Store" />
                                <Column dataField="status" caption="Status" />

                               
                            </DataGrid>


                            {/* :
                                <div className="text-center fs-5 fw-bold">
                                    <Result
                                        status="403"
                                        title="401"
                                        subTitle="Sorry, you are not authorized to access this data."
                                        className="custom-result"
                                    />
                                </div> */}
                            {/* } */}
                        </Card.Body>
                    </Card>
                </div>
            </div>


            <PdfViewerModal
                visible={showPdfModal}
                base64Data={pdfData}
                onClose={() => {
                    setShowPdfModal(false);
                    setPdfData(null);
                }}
                title={`Delivery Challan`}
            />
        </>
    )
}

export default RepairedBagList
